import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMissionGlobalState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const missionGlobalModule: Module<IMissionGlobalState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default missionGlobalModule